import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React, { useState, useContext, useEffect, useRef } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import ViewModal from "components/modal/ViewSeoModal";
import SeoPageDrawer from "components/drawer/SeoPageDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ConfirmActiveModal from "components/form/ConfirmActiveModal";
import SeoManageCityServices from "services/SeoManageCityServices";
import { notifySuccess } from "utils/toast";
import { SidebarContext } from "context/SidebarContext";
import { FiEye } from "react-icons/fi";
import Tooltip from "components/tooltip/Tooltip";

// internal imports

const SeoPageTable = ({
  hourRentalBasicRate,
  perpage,
  hideEdit,
  hideDelete,
  setOffset,
}) => {  
  const {
    title,
    serviceId,
    handleModalOpen,
    handleUpdate,
    handleView,
    isViewMode,
  } = useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);

  const [showActiveModal, setShowActiveModal] = useState(false);
  const [activeIndex] = useState(null);
  const [status] = useState(false);
  const tableRef = useRef(null); // Reference for the table container

  const handleUpdateStatusConfirm = () => {
    handleUpdateStatus(activeIndex);
    setShowActiveModal(false);
  };

  const handleUpdateStatus = async (i) => {
    const dataValues = {
      seo_active: !status,
    };
    const res = await SeoManageCityServices.updateSeoCity(i, dataValues);
    setIsUpdate(true);
    notifySuccess(res.message);
  };

  // useEffect(() => {
  //   let timeout;
  //   const handleWheel = (event) => {
  //     // Check if the scroll is inside the table container
  //     if (tableRef.current && tableRef.current.contains(event.target)) {
  //       if (timeout) return;
  //       if (event.shiftKey) {
  //         return;
  //       }
  //       timeout = setTimeout(() => {
  //         setOffset((prevOffset) => prevOffset + 100);
  //         timeout = null;
  //       }, 200);
  //     }
  //   };

    // Attach event listener to the table container instead of the window
  //   const tableElement = tableRef.current;
  //   if (tableElement) {
  //     tableElement.addEventListener("wheel", handleWheel);
  //   }

  //   return () => {
  //     if (tableElement) {
  //       tableElement.removeEventListener("wheel", handleWheel);
  //     }
  //   };
  // // }, [setOffset]);

  const handleViewResume = (resumeUrl) => {
    if (resumeUrl) {
      const fileUrl = `${resumeUrl}`;
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <SeoPageDrawer id={serviceId} isViewMode={isViewMode} />
      </MainDrawer>
      <ViewModal id={serviceId} title={title} data={hourRentalBasicRate} />

      {/* Attach ref to the table container */}
      <TableBody ref={tableRef}>
        {hourRentalBasicRate?.slice(0, perpage).map((data, index) => (
          <TableRow key={`${data.id}`}>
            <TableCell className="text-center text-sm">{index + 1}</TableCell>
            <TableCell
              className="text-center text-sm"
              style={{
                maxWidth: "250px",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              <p
                onClick={() => handleViewResume(data["url"])}
                className="hover:text-blue-500 hover:underline cursor-pointer"
              >
                {data["url"]}
              </p>
            </TableCell>
            <TableCell
              className="text-center text-sm"
              style={{
                maxWidth: "250px",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {data["keywords"]}
            </TableCell>
            <TableCell
              className="text-center text-sm"
              style={{
                maxWidth: "250px",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {data["title"]}
            </TableCell>
            <TableCell>
              <div className="flex justify-center text-right">
                <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                  <button
                    onClick={() => handleView(data.id, "SEO Details")}
                    className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                  >
                    <Tooltip
                      id={data.id}
                      Icon={FiEye}
                      title="ViewOrder"
                      bgColor="#34D399"
                    />
                  </button>
                </div>
                <EditDeleteButton
                  title={"Seo Page"}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>

      <ConfirmActiveModal
        isOpen={showActiveModal}
        onClose={() => setShowActiveModal(false)}
        onConfirm={handleUpdateStatusConfirm}
      />
    </>
  );
};

export default SeoPageTable;
